export const APP_DOMAIN = process.env.NEXT_PUBLIC_DOMAIN;
export const APP_ENV = process.env.NEXT_PUBLIC_ENVIRONMENT;
export const APP_NODE_ENV = process.env.NODE_ENV;
export const GTM_SCRIPT_ID = process.env.NEXT_PUBLIC_GTM_SCRIPT_ID;
export const LAUNCH_DARKYLY_CLIENT_ID = process.env.NEXT_PUBLIC_LAUNCH_DARKLY_CLIENT_SIDE_ID;
export const ORDER_SERVICE_API_BASE_URL = process.env.NEXT_PUBLIC_SM_API_HOST;
export const ORDER_SERVICE_API_URL = `${ORDER_SERVICE_API_BASE_URL}/api/v1/ams`;
export const PRODUCT_SERVICE_GRAPHQL_API_BASE_URL =
  process.env.NEXT_PUBLIC_PRODUCTS_GRAPHQL_API_BASE_URL;
export const REWARDS_FRONTEND_URL = process.env.NEXT_PUBLIC_STADIUM_REWARDS_URL;
export const REWARDS_SERVICE_GRAPHQL_API_BASE_URL = process.env.NEXT_PUBLIC_REWARDS_API_BASE_URL;
export const PUBNUB_PUBLISH_KEY = process.env.NEXT_PUBLIC_PUBNUB_PUBLISH_KEY;
export const PUBNUB_SUBSCRIBE_KEY = process.env.NEXT_PUBLIC_PUBNUB_SUBSCRIBE_KEY;
export const SEARCH_SERVICE_GRAPHQL_API_BASE_URL = process.env.NEXT_PUBLIC_SEARCH_API_BASE_URL;
export const USERS_FRONTEND_URL = process.env.NEXT_PUBLIC_STADIUM_USERS_URL;
export const USER_SERVICE_GRAPHQL_API_BASE_URL = process.env.NEXT_PUBLIC_USER_SERVICE_API_BASE_URL;
export const STRIPE_API_KEY = process.env.NEXT_PUBLIC_STRIPE_API_KEY;
export const ZENDESK_KEY = process.env.NEXT_PUBLIC_ZENDESK_KEY;
export const SHOPS_DASHBOARD_HOSTNAME = process.env.NEXT_PUBLIC_SHOPS_DASHBOARD_HOSTNAME;
export const GOOGLE_ANALYTICS_GA4_APPID = process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_GA4_APPID;
export const OSANO_ID = process.env.NEXT_PUBLIC_OSANO_ID;
export const WEGLOT_API_KEY = process.env.NEXT_PUBLIC_WEGLOT_API_KEY || "test-key";
export const isDev = () => process.env.NODE_ENV === "development";
export const IS_DEV = isDev();
export const isProduction = APP_ENV === "production";
export const JUNE_SO_WRITEKEY = process.env.NEXT_PUBLIC_JUNE_SO_WRITEKEY;
export const MIXPANEL_API_KEY = process.env.NEXT_PUBLIC_MIXPANEL_API_KEY;
export const CLARITY_API_KEY = process.env.NEXT_PUBLIC_CLARITY_API_KEY || "";
export const GOOGLE_RECAPTCHA_SITEKEY = process.env.NEXT_PUBLIC_GOOGLE_RECAPTCHA_SITEKEY;
export const SWAGMAGIC_GTM_SCRIPT_ID = process.env.NEXT_PUBLIC_SWAGMAGIC_GTM_SCRIPT_ID;
export const SWAGMAGIC_GOOGLE_ANALYTICS_GA4_APPID =
  process.env.NEXT_PUBLIC_SWAGMAGIC_GOOGLE_ANALYTICS_GA4_APPID;
export const SWAGMAGIC_CLARITY_API_KEY = process.env.NEXT_PUBLIC_SWAGMAGIC_CLARITY_API_KEY;
export const HUBSPOT_LOCKER_SHOP_GET_A_CALL_FORM_GUID =
  process.env.NEXT_PUBLIC_HUBSPOT_LOCKER_SHOP_GET_A_CALL_FORM_GUID || "";
export const PROMOTIONAL_STORE_NUMBER =
  process.env.NEXT_PUBLIC_PROMOTIONAL_STORE_NUMBER || process.env.NEXT_PUBLIC_LOCKER_SHOP_NUMBER;
export const PROMOTIONAL_STORE_SLUG =
  process.env.NEXT_PUBLIC_PROMOTIONAL_STORE_SLUG || process.env.NEXT_PUBLIC_LOCKER_SHOP_SLUG;
export const LOCKER_SHOP_SLUG = process.env.NEXT_PUBLIC_LOCKER_SHOP_SLUG;
export const LOCKER_SHOP_NUMBER = process.env.NEXT_PUBLIC_LOCKER_SHOP_NUMBER;
export const SWAGMAGIC_DOMAIN = process.env.NEXT_PUBLIC_PROMOTIONAL_STORE_DOMAIN;
export const IS_LOCAL_SWAGMAGIC_BUILD = process.env.NEXT_PUBLIC_BUILD_SWAGMAGIC === "true";
